import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Features } from '@shared/DTO/features';

import { MenuItemModel } from '../../models/menu-item.model';

@Component({
  selector: 'app-sidebar-item',
  templateUrl: './sidebar-item.component.html',
  styleUrls: ['./sidebar-item.component.scss']
})
export class SidebarItemComponent {
  @Input() item: MenuItemModel;
  @Input() menusExpanded: boolean;
  @Input() sidebarActive: boolean;
  @Input() currentRoute: string;
  @Input() features: Features;

  @Output() childClick: EventEmitter<any[]> = new EventEmitter();

  isCurrentRoute(route: any[]): boolean {
    if(this.currentRoute===undefined) return false;
    return this.currentRoute.includes(route[0]);
  }

  onChildClick(route: any[]) {
    this.childClick.emit(route);
  }
}
